
	import VueAMap from 'vue-amap'
	import markr from '../../../assets/bjba/map/mark_r.png'
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import {pushState} from "vue-router/src/util/push-state";
	import GdList from './map-gd-list'
	@Component({
		name: 'amap',
		components:{
			GdList
		}
	})
	export default class amap extends Vue {

		windows = []
		window={
			position:[121.506377, 31.245105],
			visible: false,
			info: {}
		}
		searchmarkers=[]
		labelPosition = "right"
		centerDialogVisible = false
		rsDisabled = false
		amapManager = new VueAMap.AMapManager()
		events = {
			click: (e: any) => {
				var _that = this
				let x = e.lnglat.lng;
				let y = e.lnglat.lat;
				let marker = [x, y];
				this.form.x = x;
				this.form.y = y;

				let newmarker = {
					icon:markr,
					position: [marker],
					vid: '0',
					events: {
						click: (e: any) => {
							this.form.x = e.lnglat.lng;
							this.form.y = e.lnglat.lat;
						}
					}
				};
				_that.clickMarkers.pop()
				_that.clickMarkers.push(newmarker);

			},
			zoomchange: (e :any) => {
				var _that = this;
				console.log(_that.$refs.amap.$$getInstance().getZoom())
				_that.zoom.zoom=_that.$refs.amap.$$getInstance().getZoom()

			}
		}
		zoom={
			zoom:12
		}
		center = [121.506377, 31.245105]
		markers = []
		clickMarkers=[]
		circles = []
		searchOption = {
			city: '上海',
			citylimit: true
		}
		deptdisable=false
		mapCenter = []
		depts=[]
		xxlx=[]
		showHxForm=false
		dialogFormVisible = false
		formLabelWidth = '80px'
		bcxxForm={
			morbc:{time:['',''],hxsj:['','']},
			aftbc:{time:['',''],hxsj:['','']},
			evebc:{time:['',''],hxsj:['','']}
		}
		form = {
			id: '',
			name: '',
			lx: '',
			x: '',
			y: '',
			jl: '',
			rs: '',
			morrs:'',
			aftrs:'',
			evers:'',
			bcList:[],
			bmid:'',
			contractId:'',
			hxgd: 0,
			sfcbb: 0,
			xxlx: '',
			wjgd: 0
		}

		tableData = []
		gdListVisible=[]
		circleVisibleFlag=true
		mapRules= {
			name: [{
				required: true,
				message: '岗点名称不能为空',
				trigger: ['blur']
			}],
			x: [{
				required: true,
				message: '经度不能为空',
				trigger: ['blur']
			}],
			y: [{
				required: true,
				message: '纬度不能为空',
				trigger: ['blur']
			}],
			jl: [{
				required: true,
				message: '距离不能为空',
				trigger: ['blur']
			},{
				validator: this.checkAge,
				message: '距离只能是数字',
				trigger: ['blur']
			}],
			morrs: [{
				validator: this.checkAge,
				message: '早班人数只能为数字',
				trigger: ['blur']
			}],
			aftrs: [{
				validator: this.checkAge,
				message: '早班人数只能为数字',
				trigger: ['blur']
			}],
			evers: [{
				validator: this.checkAge,
				message: '早班人数只能为数字',
				trigger: ['blur']
			}]
		}
		mounted() {
			this.isDisabledRs()
			this.loadtable();
			var x = this.$route.query.x;
			var y = this.$route.query.y;
			if(x && y){
				this.center = [x, y];
				this.zoom.zoom = 19;
			}
			this.getDepts()

		}
		isDisabledRs(){
			var userId = this.$store.getters.user.userId;
			var zzdyqc = this.$store.getters.user.zzdyqc;
			if (zzdyqc !== this.CONST_ZN_BM && userId !== '1' && zzdyqc !== '2c9376677a742a05017a83a643b9698b') {
				this.rsDisabled =true;
			}
			// if (zzdyqc !== this.CONST_ZN_BM && userId !== '1') {
			// 	this.rsDisabled =true;
			// }
		}
		checkAge(rule, value, callback){

			if(value) {
				if ( !/^\d+$/.test(value)) {
					callback(new Error('请输入数字值'));
				} else {
					callback();
				}
			} else callback();
		}
		onsubmitform() {

			this.$refs['gdaddForm'].validate((valid,object) => {
				console.log('1111111111111111' + object)
				if (!valid) {
					var me;
					for (var message in object) {
						me = object[message];
						break;
					}
					this.$message({
						message: me[0].message,
						type: 'error',
						center: true,
						showClose: true
					})
					return false;
				} else{
					const data = this.form
					data.bcxx = this.bcxxForm
					this.$request({
						method: 'post',
						url: '/bjba/map/addGdxx',
						data
					}).then((response: any) => {
						if(response.data.code == 200) {
							this.resetform();
							this.loadtable();
							this.$message.success("岗点设置成功！")
							if(this.$refs.gdList) this.$refs.gdList.loadData()
						}else if(response.data.code ==500) {
							this.$message({
								message: response.data.message,
								type: 'error',
								duration: 1500
							})
						}
					}).catch((response: any) => {
						this.$message.error("岗点添加失败！")
					});
				}
			})


		}
		loadtable() {
			var _that = this;
			_that.$request({
				method: 'get',
				url: '/bjba/map/loadGdxx'
			}).then((response: any) => {
				_that.markers.splice(0, _that.markers.length);
				_that.markers.length = 0;
				_that.circles.splice(0, _that.circles.length);
				_that.circles.length = 0;
				_that.windows=[]
				// _that.tableData = [];
				let data = response.data;
				for (var i = 0; i < data.length; i++) {
					let name = data[i].gdmc;
					let x = data[i].zbjd;
					let y = data[i].zbwd;
					let id = data[i].gdid;
					let jl = data[i].dkjl;
					let rs =data[i].dkrs;
					let lx =data[i].gdlx;
					let morrs = data[i].morrs;
					let aftrs = data[i].aftrs;
					let evers = data[i].evers;
					let bmid = data[i].bmid;
					let list = {
						name: name,
						x: x,
						y: y,
						id: id,
						jl: jl,
                        rs: rs,
                        lx: lx,
						morrs: morrs,
						aftrs: aftrs,
						evers: evers,
						bmid:bmid
					};
					// _that.tableData.push(list);
					let marker = [x, y];
					const element = list
					const s = i
					let newmarker = {
						position: [marker],
						vid: id,
						events: {
							mouseover:(e: any) => {
								// this.form.x = e.lnglat.lng;
								// this.form.y = e.lnglat.lat;
								// console.log(_that.markers);
								_that.window.visible = false
								this.$nextTick(() => {

									_that.window.info = element
									_that.window.visible = true
									_that.window.position = [element.x, element.y]
								})
							},
							mouseout:(e:any) => {
								// this.form.x = e.lnglat.lng;
								// this.form.y = e.lnglat.lat;
								// console.log(_that.markers);
								_that.window.visible = false
								this.$nextTick(() => {

									// _that.window.info = element
									_that.window.visible = false
									// _that.window.position = [element.lng, element.lat]
								})
							},
							click(e:any) {
								// _that.setCurrentRow(s)
							}
						}
					};
					_that.markers.push(newmarker);
					let newcircle = {
						center: marker,
						radius: jl,
						fillOpacity: 0.5,
						visible: true,
						events: {
							click: (e: any) => {
								let x = e.lnglat.lng;
								let y = e.lnglat.lat;
								let marker = [x, y];
								_that.form.x = x;
								_that.form.y = y;

								let newmarker = {
									icon:markr,
									position: [marker],
									vid: '0',
									events: {
										click: (e: any) => {
											this.form.x = e.lnglat.lng;
											this.form.y = e.lnglat.lat;
										}
									}
								};
								_that.clickMarkers.pop()
								_that.clickMarkers.push(newmarker);

							},
						}
					}
					_that.circles.push(newcircle);
					let newWindow = {
						position: marker,
						content: name,
						visible: false
					}
					_that.windows.push(newWindow)
				}
			})
		}
		changeCircleVisible() {
			this.circleVisibleFlag = !this.circleVisibleFlag
			this.circles.forEach(e=>e.visible= this.circleVisibleFlag)
		}
		// 设置列表选中行
		setCurrentRow (name) {
			this.gdListVisible = true
			this.$nextTick(()=> {
				this.$refs.gdList.init(name)
			})

		}
		onSearchResult(pois) {
			let _that=this;
			_that.searchmarkers.splice(0, _that.searchmarkers.length);
			_that.searchmarkers.length = 0;
			this.mapCenter = [];
			let latSum = 0;
			let lngSum = 0;
			if (pois.length > 0) {
				pois.forEach(poi => {
					let {lng, lat} = poi;
					lngSum += lng;
					latSum += lat;
					let marker = [poi.lng, poi.lat];
					var element = poi;
					let newmarker = {
						icon: markr,
						position: [marker],
						events:{
							click: (e: any) => {
								// this.form.x = e.lnglat.lng;
								// this.form.y = e.lnglat.lat;
								// console.log(_that.markers);
								// _that.window.visible = false
								// this.$nextTick(() => {

									this.form.x = e.lnglat.lng;
									this.form.y = e.lnglat.lat;
								// })
							},
							mouseover:(e: any) => {
								// this.form.x = e.lnglat.lng;
								// this.form.y = e.lnglat.lat;
								// console.log(_that.markers);
								_that.window.visible = false
								this.$nextTick(() => {

									_that.window.info = element
									_that.window.visible = true
									_that.window.position = [element.lng, element.lat]
								})
							},
							mouseout:(e:any) => {
								// this.form.x = e.lnglat.lng;
								// this.form.y = e.lnglat.lat;
								// console.log(_that.markers);
								_that.window.visible = false
								this.$nextTick(() => {

									// _that.window.info = element
									_that.window.visible = false
									// _that.window.position = [element.lng, element.lat]
								})
							}
						}
					}
					_that.searchmarkers.push(newmarker);
				});
				let center = {
					lng: lngSum / pois.length,
					lat: latSum / pois.length
				};
				this.mapCenter = [center.lng, center.lat];
				this.center = [center.lng, center.lat];
				this.zoom.zoom = 16;
			}
		}
		removemarker() {
			var that = this;
			that.markers.splice(0, that.markers.length);
			that.markers.length = 0;
			that.circles.splice(0, that.circles.length);
			that.circles.length = 0;
			that.clickMarkers.splice(0, that.clickMarkers.length);
			that.clickMarkers.length = 0;
			that.searchmarkers.splice(0, that.searchmarkers.length);
			that.searchmarkers.length = 0;
			that.loadtable();
		}
		resetmap() {
			this.center = [121.506377, 31.245105];
			this.zoom.zoom = 12;
			this.loadtable();
		}
		showGdList() {
			this.gdListVisible = true
			this.$nextTick(() => {
				this.$refs.gdList.init()
			})
		}
		circleedit() {
			let newcircle = {
				center: [this.form.x, this.form.y],
				radius: this.form.jl,
				fillOpacity: 0.5,
				events: {
					click: (e) => {
					}
				}
			}
			this.circles.push(newcircle);
		}
		dwClick(row) {
			console.log('33333333333   '+this.zoom)
			let x = row.zbjd;
			let y = row.zbwd;
			let jl = row.jl;
			this.center = [x, y];
			this.zoom.zoom = 19;
			// this.form={
			// 	id: row.id,
			// 	lx:'',
			// 	name: row.name,
			// 	x: row.x,
			// 	y: row.y,
			// 	jl: row.jl,
			// 	rs: row.rs
			// }
		}

        editClick(row){
		    this.form.id=row.gdid;
		    this.form.name=row.gdmc;
		    this.form.lx=row.gdlx;
		    this.form.x=row.zbjd;
		    this.form.y=row.zbwd;
		    this.form.jl=row.dkjl;
		    this.form.morrs=row.morrs;
		    this.form.aftrs=row.aftrs;
		    this.form.evers=row.evers;
		    this.form.bmid =row.bmid;
			this.form.contractId = row.contractId
			this.form.hxgd = row.hxgd
			this.form.sfcbb = row.sfcbb
			this.form.xxlx = row.xxlx
			this.form.wjgd = row.wjgd
			this.$request.get('/bjba/map/getBcTime/'+row.gdid).then(res => {
				if(res.data.data && res.data.data.length>0) {
					for(var i=0;i<res.data.data.length;i++){
						if(res.data.data[i].bclx=='1'){
							this.bcxxForm.morbc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
							this.bcxxForm.morbc.hxsj = [res.data.data[i].hxsjks,res.data.data[i].hxsjjs]
						}else if(res.data.data[i].bclx=='2'){
							this.bcxxForm.aftbc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
							this.bcxxForm.aftbc.hxsj = [res.data.data[i].hxsjks,res.data.data[i].hxsjjs]
						} else if(res.data.data[i].bclx=='3'){
							this.bcxxForm.evebc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
							this.bcxxForm.evebc.hxsj = [res.data.data[i].hxsjks,res.data.data[i].hxsjjs]
						}
					}
				} else {
					this.bcxxForm.morbc.time=['','']
					this.bcxxForm.aftbc.time=['','']
					this.bcxxForm.evebc.time=['','']
					this.bcxxForm.morbc.hxsj=['','']
					this.bcxxForm.aftbc.hxsj=['','']
					this.bcxxForm.evebc.hxsj=['','']
				}
			})
		/*	for(var i=0;i<this.depts.length;i++) {
				if(this.form.bmid === this.depts[i].bmid) {
					this.showHxForm = this.depts[i].isSchool ===1
					break;
				}
			}*/
        }
		findUser(id) {
		}
		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUserXxlx',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data.data
            	that.xxlx = res.data.xxlx
				if(this.depts && this.depts[0]) {
					var zzdyqc = this.$store.getters.user.zzdyqc;
					if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
						var zw = this.$store.getters.user.zw;
						if (zw) {
							if (zw == '01' || zw == '02' || zw == '03') {
								this.form.bmid = that.depts[0].bmid
								this.deptdisable = true
								// for(var i=0;i<this.depts.length;i++) {
								// 	if(this.form.bmid === this.depts[i].bmid) {
								// 		this.showHxForm = this.depts[i].isSchool ===1
								// 		break;
								// 	}
								// }
							}
						}
					}
				}
			})
		}
		resetform(){
			this.form.name = ''
			this.form.lx = ''
			this.form.jl = ''
			this.form.rs = ''
			this.form.id = ''
			this.form.x = ''
			this.form.y = ''
			this.form.morrs=''
			this.form.aftrs=''
			this.form.evers=''
			this.form.bmid=''
			this.form.hxgd=0
			this.bcxxForm.morbc.time=['','']
			this.bcxxForm.aftbc.time=['','']
			this.bcxxForm.evebc.time=['','']
			this.bcxxForm.morbc.hxsj=['','']
			this.bcxxForm.aftbc.hxsj=['','']
			this.bcxxForm.evebc.hxsj=['','']
			this.form.sfcbb=0
			this.form.xxlx=''
			this.form.wjgd=0
		}
		changeBm(depttype) {
			this.showHxForm = depttype==1
			if(!this.showHxForm) {
				this.bcxxForm.morbc.hxsj=['','']
				this.bcxxForm.aftbc.hxsj=['','']
				this.bcxxForm.evebc.hxsj=['','']
			}
		}
		changeSelect(dept) {
			if(!dept) this.showHxForm = false
		}
	}
